import React from "react"
import { Button as AntButton } from 'antd'
import {ButtonContainer} from './style'

function Button(props) {

    return(
        <ButtonContainer>
            <AntButton href={props.href} onClick={props.onClick} disabled={props.disabled} style={{width:props.width, height:'48px', backgroundColor:'black', borderRadius:'4px', color:'white',borderColor:'black', boxShadow:'unset', fontSize:'16px'}}>
                {props.text?props.text:'Smart Store'}
            </AntButton>
        </ButtonContainer>
    )
}

export default Button